/* eslint-disable */
import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { API } from 'src/services/config'

export interface VaccineRecord {
  id: string;
  idAnimal: string;
  vacina: string;
  dataAplicacao: string;
}

export interface VaccineHistoryState {
  isLoading: boolean;
  list: Array<VaccineRecord>;
}

const customModule = '@VACCINE_HISTORY'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
}

const SET_LOADING = `${customModule}/SET_LOADING`

const initialState: VaccineHistoryState = {
  isLoading: false,
  list: [],
}

export const vaccineHistoryReducer: Reducer<VaccineHistoryState> = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET.REQUEST:
      return { ...state, isLoading: true }
    case GET.SUCCESS:
      return { ...state, list: payload, isLoading: false }
    default:
      return state
  }
}

// Action creators
export const setLoading = (isLoading: boolean) => ({ type: SET_LOADING, payload: isLoading })
export const getVaccineHistoryByAnimal = (farmId: string, animalId: string) => ({ type: GET.REQUEST, payload: { farmId, animalId } })

const ROUTE = '/entity/AnimalHistoricoVacinas'

// Saga para buscar o histórico de vacinas
function* get({ payload }: SagaAction<{ farmId: string, animalId: string }>) {
  const { farmId, animalId } = payload
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<VaccineRecord[]> = yield call(API.get, `${ROUTE}/${farmId}/${animalId}/AnimalHistoricoVacinas`)
    yield put({ type: GET.SUCCESS, payload: data })
  } catch (error: any) {
    console.error(error)
    // toast.error(message)
  } finally {
    yield put(setLoading(false)) // Garante que o loading será removido
  }
}

export const vaccineHistorySaga = all([
  takeLatest(GET.REQUEST, get),
])
